import { render, staticRenderFns } from "./classic-editor5.vue?vue&type=template&id=1cde1a58&scoped=true"
import script from "./classic-editor5.vue?vue&type=script&lang=ts"
export * from "./classic-editor5.vue?vue&type=script&lang=ts"
import style0 from "./classic-editor5.vue?vue&type=style&index=0&id=1cde1a58&prod&lang=css"
import style1 from "./classic-editor5.vue?vue&type=style&index=1&id=1cde1a58&prod&lang=scss&scoped=true"
import style2 from "./classic-editor5.vue?vue&type=style&index=2&id=1cde1a58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde1a58",
  null
  
)

export default component.exports